export const RECENT_SEARCH_START = 'RECENT_SEARCH_START';
export const RECENT_SEARCH_END = 'RECENT_SEARCH_END';
export const SET_SELECTED_PROPERTY = 'SET_SELECTED_PROPERTY';
export const SET_SELECTED_PROPERTY_FROM_DYNAMIC_BUBBLE = 'SET_SELECTED_PROPERTY_FROM_DYNAMIC_BUBBLE';
export const SET_DYNAMIC_COORDINATES = 'SET_DYNAMIC_COORDINATES';
export const FETCH_DYNAMIC_PROPERTY_BY_IDS = 'FETCH_DYNAMIC_PROPERTY_BY_IDS';
export const GET_PROPERTY_BY_COORDINATES_SUCCESS = 'GET_PROPERTY_BY_COORDINATES_SUCCESS';
export const GET_PROPERTY_BY_COORDINATES_FAILED = 'GET_PROPERTY_BY_COORDINATES_FAILED';
export const HANDLE_DYNAMIC_PROPERTY_SELECTED = 'HANDLE_DYNAMIC_PROPERTY_SELECTED';
export const startRecentSearchProgress = () => {
    return {
        type: RECENT_SEARCH_START,
    };
}

export const handleDynamicPropertySelected = (payload) => {
    return {
        type: HANDLE_DYNAMIC_PROPERTY_SELECTED,
        payload,
    };
}

export const endRecentSearchProgress = () => {
    return {
        type: RECENT_SEARCH_END,
    };
}

export const setSelectedProperty = (details) => ({
    type: SET_SELECTED_PROPERTY,
    payload: details,
});

export const setSelectedPropertyFromDynamicBubble = (id) => ({
    type: SET_SELECTED_PROPERTY_FROM_DYNAMIC_BUBBLE,
    payload: id,
});

export const setDynamicCoordinates = (coordinates) => ({
    type: SET_DYNAMIC_COORDINATES,
    payload: coordinates,
});

export const fetchDynamicPropertyByIds = ({ propertyIds, mixpanel, isRadiusSearch = false }) => ({
    type: FETCH_DYNAMIC_PROPERTY_BY_IDS,
    payload: { propertyIds, mixpanel, isRadiusSearch },
});
